// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3FkC_","author":"Table_author__2_o97","authorImage":"Table_authorImage__Sk9Eq","unreadRow":"Table_unreadRow__2ANYc"};